import React from 'react'
import { motion } from 'framer-motion'
import buildImage from '../../../assets/images/tatvacare/whatyoubuild.webp'
import brainIcon from '../../../assets/images/tatvacare/whatwebuild.webp'
import whatwebuildline from '../../../assets/images/tatvacare/whatwebuildline.svg'

const buildPoints = [
  'Conversational AI interface for natural queries',
  'Integration with trusted medical sources (like IAP guidelines)',
  'Smart answer structuring with references',
  'Personalized doctor profiles',
  'History tracking for continuous workflows',
  'Related query suggestions for deeper exploration',
]

const TatvacareWhatyoubuild = () => {
  return (
    <section className="relative h-[700px] w-full overflow-hidden bg-black/10 pt-10 pb-0 md:h-[800px] lg:h-[500px] xl:h-[650px] 2xl:h-[950px] xl:pt-15">

      <div className="relative z-20 mx-auto flex w-full max-w-[95%]  flex-col lg:flex-row lg:items-start lg:justify-between">

        {/* LEFT CONTENT */}
        <div className="relative order-1 w-full lg:w-[72%]">

          {/* HEADING */}
          <div className="flex items-end pl-4 md:pl-7 justify-start">

            <img
              src={brainIcon}
              alt="What we built icon"
              className="h-8 w-8 shrink-0 md:h-10 md:w-10 lg:h-12 lg:w-12"
            />

            <h2 className="font-gilroy-bold  text-2xl text-white md:text-4xl lg:text-4xl xl:text-5xl 2xl:text-6xl">
              What We Built
            </h2>

            <span className="mb-1 h-[2px] w-12 md:w-28 rounded-full bg-black" />

          </div>

          {/* PARA */}
          <p className="mt-4 pl-4 md:pl-7  max-w-[900px] font-gilroy-medium text-sm leading-normal text-white/70 md:text-lg lg:text-lg xl:text-xl 2xl:text-3xl">
            A seamless ecosystem that blends AI intelligence with medical credibility:
          </p>

          {/* IMAGE → md only below heading */}
          <div className="order-2 mt-6 flex w-full justify-center lg:hidden">

            <img
              src={buildImage}
              alt="TatvaCare Build"
              className="w-[55%] object-contain md:w-[40%] lg:w-[45%]"
            />

          </div>

          {/* CARDS */}
   

<div
  className="
    relative
    order-3
    mt-2
    grid
    grid-cols-1
    gap-2
    px-2

    md:mt-7
    md:grid-cols-2
    md:gap-x-6
    md:gap-y-10
    md:pb-20

    xl:mt-10
    xl:grid-cols-2
    xl:gap-x-10
    xl:gap-y-8

    2xl:gap-y-14
  "
>

  {buildPoints.map((item, idx) => {
    const isRight = idx % 2 !== 0

    return (
      <motion.div
        key={idx}
        initial={{
          opacity: 0,
          scale: 0.65,
        }}
        whileInView={{
          opacity: 1,
          scale: 1,
        }}
        viewport={{
          once: false,
          amount: 0.3,
        }}
        transition={{
          duration: 0.5,
          delay: idx * 0.08,
          ease: 'easeOut',
        }}
        className={`
          flex
          min-h-[45px]
          items-center
          rounded-[8px]
          bg-white
          pl-4
          shadow-xl

          md:min-h-[50px]
          md:px-4
          md:py-2
 
          lg:min-h-[60px]
          lg:px-3
          lg:py-2

          xl:min-h-[90px]

          2xl:min-h-[120px]
          2xl:px-10
          2xl:py-5

          ${
            isRight
              ? 'md:translate-y-11 xl:translate-y-15 2xl:translate-y-30'
              : ''
          }
        `}
      >

        <p className="font-gilroy-medium text-sm leading-snug text-black md:text-base xl:text-xl 2xl:text-2xl">
          • {item}
        </p>

      </motion.div>
    )
  })}

</div>

        </div>

        {/* DESKTOP IMAGE */}
        <div className="relative hidden lg:absolute lg:right-[-2%] lg:top-[15%] lg:flex lg:w-[38%] lg:items-end lg:justify-center xl:right-[0%] xl:top-[8%] xl:w-[36%] 2xl:top-[15%] 2xl:w-[30%]">

          <img
            src={buildImage}
            alt="TatvaCare Build"
            className="relative z-20 w-[85%] object-contain"
          />

        </div>

      </div>

      {/* SVG LINE */}
<div className="pointer-events-none absolute bottom-[9%] left-0 z-10 w-full overflow-hidden md:bottom-[10%] lg:bottom-[8%] xl:bottom-[10%] 2xl:bottom-[10%]">

  <style>
    {`
      @keyframes heartbeatLoop {
        from {
          transform: translateX(-50%);
        }

        to {
          transform: translateX(0%);
        }
      }

      .heartbeat-loop {
        animation: heartbeatLoop 14s linear infinite;
        width: max-content;
        display: flex;
        will-change: transform;
      }
    `}
  </style>

  <div className="heartbeat-loop">

    <img
      src={whatwebuildline}
      alt=""
      aria-hidden
      className="shrink-0 w-screen object-cover lg:h-[50px] xl:h-[80px] 2xl:h-[100px]"
    />

    <img
      src={whatwebuildline}
      alt=""
      aria-hidden
      className="shrink-0 w-screen object-cover lg:h-[50px] xl:h-[80px] 2xl:h-[100px]"
    />

  </div>

</div>

    </section>
  )
}

export default TatvacareWhatyoubuild